export const PRINTQRCONSTANTS = Object.freeze({
  ASSET: "ASSET",
  FORMAT_TYPE_IMAGE: "image",
  FORMAT_TYPE_PDF: "pdf",
  BIG: "big",
  LARGE: "large",
  LOC: "LOC",
  MEDIUM: "medium",
  PART: "PART",
  SMALL: "small",
});
